import React, { useMemo } from 'react';

import { DrawerComponent } from 'components/Drawer';

import * as S from './styles';
import moment from 'moment';

import { formatCurrency } from 'pages/PlanDetails';
import { Line } from 'components/Line';
import { ToolTip } from 'components/ToolTip';
import { ToolTipIcon } from 'components/Icons';

interface IDetailsKenloLeads {
  closeDrawer: () => void;
  balance: any;
  infoQualifier: any;
  signature: any;
}
const DetailsKenloLeads = ({
  closeDrawer,
  balance,
  infoQualifier,
  signature,
}: IDetailsKenloLeads) => {
  const percentage = useMemo(() => {
    const amount = signature?.product?.qty_leads ?? signature?.amount ?? 0;

    if (balance?.balance_contract === 0 || amount === 0) {
      return '0';
    }
    return ((balance?.balance_contract / amount) * 100).toFixed(2).toString();
  }, [
    balance?.balance_contract,
    signature?.amount,
    signature?.product?.qty_leads,
  ]);
  return (
    <DrawerComponent
      open
      size="default"
      // className={styles.drawer}
      onCompleteClose={closeDrawer}
      titleClose={'Detalhes do plano'}
    >
      <>
        <S.ContentDetails>
          <S.TextAside
            fontSize="20"
            fontWeight="700"
            style={{ marginBottom: '16px' }}
          >
            Kenlo Leads
          </S.TextAside>
          <S.Grid>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                Data de contratação
              </S.TextAside>
              <S.TextAside>
                {moment(infoQualifier?.activationDate).format('DD/MM/YYYY')}
              </S.TextAside>
            </div>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                Data de renovação
              </S.TextAside>
              <S.TextAside>
                {moment()
                  .add(1, 'month')
                  .startOf('month')
                  .format('D[º] [de] MMMM')}
              </S.TextAside>
            </div>
          </S.Grid>
          <S.Grid>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                Frequência
              </S.TextAside>
              <S.TextAside>{infoQualifier?.planFrequency}</S.TextAside>
            </div>
            <div>
              <S.TextAside fontSize="12" color="#808080">
                Valor
              </S.TextAside>
              <S.TextAside>
                {formatCurrency(infoQualifier?.installmentValue || 0)}
              </S.TextAside>
            </div>
          </S.Grid>
          <S.TextAside fontSize="12" color="#808080">
            Saldo disponível
          </S.TextAside>
          <S.TextAside style={{ display: 'flex', gap: '8px' }}>
            {balance?.balance_contract}
            <S.TextAside fontSize="12" color="#808080">
              /{signature?.product?.qty_leads ?? signature?.amount ?? 0}
            </S.TextAside>
          </S.TextAside>
          <S.ProgressBar percentage={percentage} />

          {balance?.balance_bought ? (
            <>
              <Line width="100%" border="1px" />
              <S.TextAside
                fontSize="20"
                fontWeight="700"
                style={{ marginBottom: '16px' }}
              >
                Leads avulsos{' '}
                <ToolTip
                  right="2rem"
                  height="3rem"
                  content={
                    'Os leads avulsos não expiram e são consumidos apenas quando o saldo do plano acabar.'
                  }
                  icon={<ToolTipIcon />}
                />
              </S.TextAside>
              <S.Grid>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Última contratação
                  </S.TextAside>
                  <S.TextAside>
                    {balance.last_bought &&
                      moment(balance.last_bought).format('DD/MM/YYYY')}
                  </S.TextAside>
                </div>
                <div>
                  <S.TextAside fontSize="12" color="#808080">
                    Saldo disponível
                  </S.TextAside>
                  <S.TextAside>{balance?.balance_bought}</S.TextAside>
                </div>
              </S.Grid>
            </>
          ) : (
            <></>
          )}
        </S.ContentDetails>
      </>
    </DrawerComponent>
  );
};
export default DetailsKenloLeads;
